import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { listInvoicesApiV1InvoiceGet } from "@/client";
import { columns } from "@/components/InvoiceTable/columns";
import { DataTable } from "@/components/InvoiceTable/data-table";
import { LoadingComponent } from "@/components/LoadingComponent";
import { useAuth } from "@/hooks/useAuth";
import { checkPermission } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/invoices")({
  component: InvoicesPage,
  beforeLoad: () => {
    checkPermission("invoice:read");
  },
});

function InvoicesPage() {
  const { user } = useAuth();
  const { data, isLoading, error } = useQuery({
    queryKey: ["clientSheets", user?.selected_client_id],
    queryFn: () => listInvoicesApiV1InvoiceGet(),
    enabled: !!user?.selected_client_id,
  });

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (isLoading || !data) {
    return <LoadingComponent />;
  }

  return <DataTable columns={columns} data={data.data} isLoading={isLoading} />;
}
